import { Box, Stack, StackProps, styled } from '@mui/material';
import { Body1, Body2 } from '@/components/@IntranetLibrary/Typography';
import React from 'react';

type SectionHeaderProps = {
  title: string;
  subTitle?: string;
} & StackProps;

export const SectionHeader = styled(
  ({ title, subTitle, ...props }: SectionHeaderProps) => (
    <Stack {...props}>
      <Body1 sx={{ fontWeight: 700 }}>{title}</Body1>
      {subTitle && <Body2>{subTitle}</Body2>}
    </Stack>
  ),
)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

type TagBoxProps = { tags: string[] } & StackProps;
export const TagBox = styled(({ tags, ...props }: TagBoxProps) => (
  <Stack {...props}>
    {tags.map((tag, index) => (
      <Box key={index} className={'tag'}>
        {tag}
      </Box>
    ))}
  </Stack>
))`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px;
  border-radius: 8px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  .tag {
    padding: 3px 7px;
    border-radius: 4px;
    border: 1px solid var(--dk-text-secondary, #888d96);
    background: var(--dk-bg-strong, #e7e9ec);
    line-height: 18px;
    font-weight: 400;
    font-size: 12px;
  }
`;
